// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "pl-" + chunkId + "." + {"474":"22d1085b","708":"bb05443c","823":"30e1bbae"}[chunkId] + ".js";
};